import React from 'react';
import { RecoilRoot } from 'recoil';
import Root from './Root';
// ==============================|| APP ||============================== //
import CustomToaster from 'ui-component/CustomToaster';
import { SettingsProvider } from './contexts/SettingsContext';


const App = () => {
  return (
    <RecoilRoot>
      <SettingsProvider>
        <React.Suspense fallback={<div>Loading...</div>}>
          <Root />
          <CustomToaster />
        </React.Suspense>
      </SettingsProvider>
    </RecoilRoot>
  );
};

export default App;
